<template>
  <el-container>
    <el-header height="65px">
      <img src="../../assets/images/wz_logo_c.png" alt="吾征AI" title="返回首页" class="backlogo" @click="shouye">
      <h1>用户中心</h1>
      <div class="headerRbox">
        <ul>
          <li v-if="!isMechanism && !isProfession" @click="tozj">专家入驻</li>
          <li v-if="!isMechanism && !isProfession" @click="toJigou">机构入驻</li>
          <li v-if="isRole !='' && isRole != null && isRole != undefined" class="borR" @click="goConsole">控制台</li>
        </ul>
      </div>
      <div class="user-el-menu-demo" style="">
        <el-menu mode="horizontal" router>
          <el-submenu index="0">
            <template slot="title">
              <img class="tximg" :src="avatar" v-if="avatar!==''">
              <div class="tximgDiv" v-else>
                <img src="../../assets/images/back/defTx.png" alt="">
              </div>
              <h3 class="username">{{userName}}</h3>
            </template>
            <el-menu-item index="/personCenter/healthRecords">基本信息</el-menu-item>
            <el-menu-item index="/personCenter/changePass">修改密码</el-menu-item>
            <!--  <el-menu-item>设备绑定</el-menu-item> -->
            <el-menu-item @click.native="logout">退出</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </el-header>
    <el-container>
      <el-aside width="210px">
        <div style="position: relative; padding-top:20px;">
          <!-- 菜单导航      -->
          <el-menu :default-active="path" active-text-color="#00A050" router class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :default-openeds="openeds" :unique-opened="true">
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-msg"></i>
                <span>我的信息</span>
              </template>
              <el-menu-item index="/personCenter/healthRecords"> 健康档案</el-menu-item>
              <el-menu-item index="/personCenter/realNameAuth">实名认证</el-menu-item>
              <el-menu-item index="/personCenter/zizhiAuth">资质认证</el-menu-item>
              <el-menu-item index="/personCenter/changePass">密码修改</el-menu-item>
            </el-submenu>
             <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-data"></i>
                <span>我的工具</span>
              </template>
               <el-menu-item index="" @click="waibu()">AI体检解读</el-menu-item>
              
              <!-- <a href="http://diag.wuzhengai.com/sheetlist" target="_blank">
                <el-menu-item index="">化验单</el-menu-item>
              </a> -->
             <a :href="'http://diag.wuzhengai.com/medicineindex?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#8">中西医AI辩证分型</el-menu-item>
              </a>
              <a :href="'http://diag.wuzhengai.com/cancerpslist?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#2">AI四高筛查</el-menu-item>
              </a>
              <a :href="'http://diag.wuzhengai.com/cancerlist?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#3">AI肿瘤筛查</el-menu-item>
              </a>
              <a :href="'http://diag.wuzhengai.com/diseaseslist?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#6">AI慢性病筛查</el-menu-item>
              </a>
              <a :href="'http://diag.wuzhengai.com/cardiovascularlist?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#4">AI心脑血管筛查</el-menu-item>
              </a>
          <!--      <a :href="'http://diag.wuzhengai.com/skinai?userId='+userid" target="_blank">
                <el-menu-item index="#1">AI医学影像筛查</el-menu-item>
              </a> -->
              <a :href="'http://diag.wuzhengai.com/blackspotindex?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#9">AI黑色素瘤影像筛查</el-menu-item>
              </a>
              <a :href="'http://diag.wuzhengai.com/skinai?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#10">AI皮肤影像筛查</el-menu-item>
              </a>
              <a :href="'http://diag.wuzhengai.com/cancercopylist?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#5">AI急性疾病筛查</el-menu-item>
              </a>
              
              <a :href="'https://wzai.wuzhengai.com/dietindex?userId='+userid+'&createDataUserId='+userid" target="_blank">
                <el-menu-item index="#7">饮食AI行为预警</el-menu-item>
              </a>
              
        
            </el-submenu>
           <!--  <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-data"></i>
                <span>报告记录</span>
              </template>
              <el-menu-item index="/personCenter/questionnaire">微问卷</el-menu-item>
              <el-menu-item index="/personCenter/znjcIndex">微体检</el-menu-item>
              <el-menu-item index="/personCenter/aizbIndex">微模态</el-menu-item>
              <el-menu-item index="/personCenter/xinliQuestion">微心理</el-menu-item>
              <el-menu-item index="/personCenter/paizheng">微图像</el-menu-item>
              <el-menu-item index="" @click="waibu()">健康中心</el-menu-item>
            </el-submenu> -->
        <!--     <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-project"></i>
                <span>我的项目</span>
              </template>
              <a href="http://wz.wuzhengai.com" target="_blank">
                <el-menu-item index="">防疫物资对接</el-menu-item>
              </a>
                <a :href="'http://bgm.wuzhengai.com/index?token='+Token" target="_blank"><el-menu-item index="">吾医管家</el-menu-item></a>
            </el-submenu> -->
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-orderList"></i>
                <span>订单管理</span>
              </template>
              <el-menu-item index="/personCenter/myOrder">我的订单</el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-vip"></i>
                <span>会员中心</span>
              </template>
              <el-menu-item index="/personCenter/memberCenter">会员中心</el-menu-item>
              <el-menu-item index="/personCenter/iamPromoter">我是推广主</el-menu-item>
            </el-submenu>
          </el-menu>
          <!-- 菜单导航   -->
        </div>
      </el-aside>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import { profile } from '@/api/user'
import '@/assets/css/backcommon.css'
export default {
  name: "personCenter",
  data () {
    return {
      userid:'',
      userData:{info:{}},
      Token: '',
      userName: '',
      avatar: '',
      openeds: ["1"],
      uniqueOpened: false,
      path: "/personCenter/healthRecords",
      isMechanism: true,
      isProfession: true,
      isRole: null,
    }
  },
  components: {},
  beforeMount () {
    // console.log(this.$route);;
  },
  mounted () {
   
       this.Token = this.$store.getters.token;
       this.profile();
       // this.userData = this.$store.state.user;
       
  },
  beforeUpdate () {
    // console.log(this.$route);
  },
  updated () {

  },
  created () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    /*window.addEventListener("resize", this.getHeight);
    this.getHeight();*/
  },
  methods: {
    waibu(){
       let token='';
          if(localStorage.getItem('userxinxi')){
               token = localStorage.getItem('userxinxi');
          }
          window.open("http://tjv.wuzhengai.com/examination?token="+token, '_blank')
          // window.location.href = ;
        //  const token = this.$store.getters.token;
        //  console.log('https://tjv.wuzhengai.com/examination?token='+token)
        // window.open('https://tjv.wuzhengai.com/examination?token='+token, '_blank')
      //   $.extend({
      //     PostSubmitForm: function (url, args) {
      //         var body = $(document.body),
      //               form = $("<form method='post' style='display:none'></form>"),
      //           input;
      //         form.attr({ "action": url });
      //         $.each(args, function (key, value) {
      //             input = $("<input type='hidden'>");
      //             input.attr({ "name": key });
      //             input.val(value);
      //             form.append(input);
      //         });

      //         form.appendTo(body);
      //         form.submit();
      //         body.removeChild(form[0]);
      //     }
      // });
      // let _this = this;
      // Cookies.set('typein',1);
      // profile().then(response => {
      //   if (response.data.code == 200) {
      //   //  $.PostSubmitForm('http://172.16.10.26:8087/densecare-web-admin/logins', {username:response.data.data.phone });
      // $.PostSubmitForm('http://dense.wuzhengai.com/densecare-web-admin/logins', {username:response.data.data.phone });
      //   }else{
      //     // _this.$router.push('login');
      //   }
      // })
    },
    // 登出
    async logout () {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        /*this.$store.dispatch('LogOut').then(() => {
          location.reload()
        })*/
        removeToken();
        this.$router.push('/login');

      })
    },
    shouye () {
      this.$router.push('/');
    },
    // 机构入驻
    toJigou () {
      this.$router.push('/personCenter/zizhiAuth/zizhiAuthJigou_jbxx');
    },
    // 专家入驻
    tozj () {
      this.$router.push('/personCenter/zizhiAuth/zizhiAuthZj_smrz');
    },
    // 获取当前登录账户个人信息
    profile () {
      let _this = this;
      _this.$store.dispatch("GetInfo").then(() => {
        _this.userName = _this.$store.getters.name;
        _this.avatar = _this.$store.getters.info.picImg;
        _this.isMechanism = _this.$store.getters.isMechanism;
        _this.isProfession = _this.$store.getters.isProfession;
        _this.isRole = _this.$store.getters.roleGroup;
        _this.userid = _this.$store.getters.userId;
      });
    },
    goConsole () {
      const token = this.$store.getters.token;
      window.location.href = "http://bgm.wuzhengai.com/index?token=" + token;
      /* window.location.href = "http://wzai.jrdsj.com/index?token=" + token;*/
    },
    // menu
    handleOpen (key, keyPath) {

    },
    handleClose (key, keyPath) {

    }
  },
  watch: {
    "$store.state.user.name": {
      handler (newVal, oldVal) {
        this.userName = newVal;
      },
      immediate: true
    },
    "$store.state.user.avatar": {
      handler (newVal, oldVal) {
        this.avatar = newVal;
      },
      immediate: true
    },
    "$route": {
      handler (to, from) {
        var pathAry = to.path.split("/");
        this.path = "/" + pathAry[1] + "/" + pathAry[2];
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
body,
html {
  width: 100%;
  height: 100%;
}
.el-container {
  /*  background-color: #F3F5F7!important;*/
  height: 100%;
}
.el-header {
  line-height: 65px;
  background-color: #ffffff;
  -moz-box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.1);
  z-index: 999;
  position: fixed;
  width: 100%;
}
.el-aside {
  display: block;
  position: fixed;
  top: 50px;
  left: 0;
  bottom: 0;
  overflow: hidden;
  padding-top: 20px;
  padding-left: 5px;
  background-color: #ffffff;
  /*height: calc(100vh);*/
  -moz-box-shadow: 3px 0px 5px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 3px 0px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 0px 5px rgba(0, 0, 0, 0.1);
  z-index: 9;
}
.el-menu-item {
  height: 40px;
  line-height: 40px;
  padding-left: 58px !important;
  color: #666666;
  font-size: 14px;
}
/*.el-main {
   -moz-box-shadow:0px 0px 15px rgba(0,0,0,0.1);
    -webkit-box-shadow:0px 0px 15px rgba(0,0,0,0.1);
    box-shadow:0px 0px 15px rgba(0,0,0,0.1);
    margin: 20px 20px;
  background-color: #ffffff;
}*/
.el-header .backlogo {
  width: 128px;
  height: 32px;
  display: inline-block;
  margin-top: 16px;
  margin-left: 24px;
  cursor: pointer;
}
.el-header h1 {
  margin: 0;
  margin-left: 56px;
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  color: rgb(164, 164, 164);
}
.el-header .headerRbox {
  position: absolute;
  top: 0;
  right: 237px;
}
.el-header .headerRbox ul {
  margin: 0;
  display: inline-block;
}
.el-header .headerRbox li {
  cursor: pointer;
  display: inline-block;
  width: 100px;
  line-height: 50px;
  color: #666666;
  font-size: 16px;
}
.el-header .user-el-menu-demo {
  display: inline-block;
  position: absolute;
  /*top: 10px;*/
  /*width: 200px;*/
  padding-left: 40px;
  right: 0px;
  padding-right: 30px;
}
.el-header .headerRbox li.borR {
  border-right: 1px solid #dedede;
}
.el-header .user-el-menu-demo .el-menu.el-menu--horizontal {
  border: none;
}
.el-header
  .headerRbox
  .user-el-menu-demo
  .el-menu--horizontal
  > .el-submenu
  .el-submenu__title {
  height: 33px;
  line-height: 53px;
  border-bottom: 2px solid transparent;
  color: #909399;
}
.el-header .user-el-menu-demo .el-menu .tximg {
  width: 34px;
  height: 34px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 20px;
}
.el-header .user-el-menu-demo .el-menu .username {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
}
.el-header .tximgDiv {
  display: inline-block;
  border-radius: 50%;
  margin-right: 20px;
  width: 34px;
  height: 34px;
  background-color: #14c86c;
  text-align: center;
  line-height: 34px;
}
.el-header .tximgDiv img {
  width: 20px;
  height: 20px;
}
.el-submenu__title i {
  width: 18px;
  height: 18px;
  background-size: 18px 18px;
}
.el-icon-msg {
  background: url("../../assets/images/personCenter/icon/msg_icon.png");
}
.el-icon-data {
  background: url("../../assets/images/personCenter/icon/data_icon.png");
}
.el-icon-orderList {
  background: url("../../assets/images/personCenter/icon/orderList_icon.png");
}
.el-icon-project {
  background: url("../../assets/images/personCenter/icon/project_icon.png");
}
.el-icon-vip {
  background: url("../../assets/images/personCenter/icon/vip_icon.png");
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/personCenter.vue